<template>
    <div>
        <div class="row">
            <h1>Pedidos Varejo</h1>
        </div>
        <div class="row mt-3">
            <b-button variant="primary" size="sm" class="mr-2" @click="voltar"><i class="fas fa-arrow-left"></i>
                Voltar</b-button>
            <b-button v-if="hasPermission('varejo_propostas')" variant="primary" size="sm" class="mr-2"
                @click="propostaVarejo">
                <i class="fas fa-fire"></i> Propostas Varejo
            </b-button>
        </div>
        <div class="row mt-2">
            <b-card class="col-md-12">
                <b-form-group>
                    <b-row align-v="end">
                        <b-col cols="1">
                            <label for="">Pedido</label>
                            <b-form-input size="sm" id="filter-input" v-model="filtro.pedido" type="search"
                                @keyup.enter="listaPedidos()">
                            </b-form-input>
                        </b-col>
                        <b-col cols="2">
                            <label for="">Cliente</label>
                            <b-form-input size="sm" id="filter-input" v-model="filtro.cliente" type="search"
                                placeholder="Código ou Nome" @keyup.enter="listaPedidos()">
                            </b-form-input>
                        </b-col>
                        <b-col cols="2">
                            <label for="">Pedido Protheus</label>
                            <b-form-input size="sm" id="filter-input" v-model="filtro.protheus" type="search" placeholder="Código"
                                @keyup.enter="listaPedidos()">
                            </b-form-input>
                        </b-col>
                        <b-col cols="2">
                            <label for="">Nota Fiscal</label>
                            <b-form-input size="sm" id="filter-input" v-model="filtro.nota" type="search" placeholder="Número"
                                @keyup.enter="listaPedidos()">
                            </b-form-input>
                        </b-col>
                        <b-col cols="1">
                            <label for="">Tipo</label>
                            <b-form-select size="sm" v-model="filtro.tipo" :options="optionsTipo"></b-form-select>
                        </b-col>
                        <b-col cols="1">
                            <label for="">Situação</label>
                            <b-form-select size="sm" v-model="filtro.status" :options="optionsStatus"></b-form-select>
                        </b-col>
                        <b-col>
                            <b-button :disabled="isLoading" size="sm" variant="primary" @click="listaPedidos()">
                                <i class="fas fa-search"></i> Buscar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-table hover class="mt-2" show-empty small :items="pedidos" :busy="isLoading" :fields="header"
                    stacked="md" empty-text="Nenhum pedido encontrado ...">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando ...</strong>
                        </div>
                    </template>
                    <template #cell(proposta)="row">
                        <a href="#" @click="verProposta(row.item.proposta.id)">{{ row.item.proposta.id }}</a>
                    </template>
                    <template #cell(actions)="row">
                        <b-button v-show="row.item.xml.length > 0" title="Nota Fiscal" variant="success" size="sm"
                            @click="gerarNota(row.item.id)">
                            <i class="far fa-file-pdf"></i>
                        </b-button>
                        <b-button v-if="row.item.xml.length && row.item.xml[0].xml_brinde" title="Nota Fiscal Brinde"
                            variant="outline-success" size="sm" @click="gerarNotaBrinde(row.item.id)">
                            <i class="far fa-file-pdf"></i>
                        </b-button>
                        <b-button title="Detalhar Pedido" variant="primary" size="sm" @click="imprimir(row.item.id)">
                            <i class="fa fa-file-alt"></i>
                        </b-button>
                        <b-button v-if="hasFalta(row.item)" title="Gerar Pedido Faltante" variant="warning" size="sm"
                            @click="getPedidoFaltante(row.item.id)">
                            <i class="fas fa-recycle"></i>
                        </b-button>
                    </template>
                </b-table>
                <b-row>
                    <b-col class="text-left">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                            @input="listaPedidos()" align="fill" class="my-0"></b-pagination>
                    </b-col>
                    <b-col cols="1">
                        <b-select v-model="perPage" :options="[5, 10, 20, 50, 100]" title="Por Página"></b-select>
                    </b-col>
                    <b-col class="text-right">
                        Total de Registros: {{ totalRows }}
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <b-modal v-model="modalPedido" size="xl">
            <template #modal-title>
                Pedido: {{ pedidoFaltas.id }}
            </template>
            <b-card v-if="pedidoFaltas.id">
                <b-overlay :show="loadingFalta" rounded="sm">
                    <b-row>
                        <b-col>
                            <b>Cliente:</b> {{ pedidoFaltas.distribuidor.codigo }} - {{ pedidoFaltas.distribuidor.nome
                            }}
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col>
                            <b>Tipo da Proposta: </b> {{ pedidoFaltas.proposta.tipo_proposta }}
                        </b-col>
                        <b-col>
                            <b>Status: </b> {{ pedidoFaltas.status }}
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col>
                            <b>Data do Pedido: </b> {{ formatDate(pedidoFaltas.created_at) }}
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-table :items="pedidoFaltas.itens" :fields="fieldsPedidoFaltas" small striped>
                            <template #cell(actions)="row">
                                <div style="width: 50px;">
                                    <b-form-input size="sm" v-model="row.item.qtd_recuperar"
                                        @change="!row.item.qtd_recuperar || row.item.qtd_recuperar == '' || row.item.qtd_recuperar > row.item.qtdARecuperar || row.item.qtd_recuperar <= 0 ? row.item.qtd_recuperar = row.item.qtdARecuperar : row.item.qtd_recuperar" />
                                </div>
                            </template>
                        </b-table>
                    </b-row>
                </b-overlay>
            </b-card>
            <template #modal-footer>
                <b-button variant="primary" size="sm" @click="gerarPedidoFaltante()" :disabled="loadingFalta">
                    <i class="fas fa-recycle"></i> Gerar Pedido de Faltas
                </b-button>
                <b-button variant="danger" size="sm" @click="modalPedido = false"
                    :disabled="loadingFalta">Cancelar</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: "proposta-venda-direta",
    data() {
        return {
            fieldsPedidoFaltas: [
                {
                    key: 'produto', label: 'Produto',
                    formatter: (value, key, item) => {
                        return item.produto.codigo + ' - ' + item.produto.descricao
                    },
                },
                { key: 'quantidade', label: 'Qtd.', class: 'text-center' },
                { key: 'quantidade_atendida', label: 'Atendido', class: 'text-center' },
                {
                    key: 'brinde', label: 'Brinde', class: 'text-center',
                    formatter: (value, key, item) => {
                        return value ? 'Sim' : 'Não'
                    },
                },
                { key: 'actions', label: 'Recuperar', class: 'text-center' },
            ],
            permissions: [],
            totalRows: 0,
            currentPage: 1,
            filtro: {
                cliente: '',
                tipo: null,
                protheus: '',
                status: null,
                nota: '',
                pedido: ''
            },
            perPage: 20,
            pedidos: [],
            isLoading: false,
            optionsStatus: [
                { value: null, text: '' },
                { value: 'ABERTO', text: 'Aberto' },
                { value: 'ANALISE_CREDITO', text: 'Análise de Crédito' },
                { value: 'SEPARANDO', text: 'Separando' },
                { value: 'FATURADO', text: 'Faturado' },
                { value: 'TRANSPORTADORA', text: 'Transportadora' },
                { value: 'CANCELADO', text: 'Cancelado' },
            ],
            optionsTipo: [
                { value: null, text: '' },
                { value: 'VENDA', text: 'Venda' },
                { value: 'AMOSTRA', text: 'Amostra' },
                { value: 'AMOSTRA_DISTRIBUIDOR', text: 'Amostra Distribuidor' },
                { value: 'REQUISICAO', text: 'Requisição' },
                { value: 'BONIFICACAO', text: 'Bonificação' }
            ],
            header: [
                {
                    key: 'id',
                    label: 'Pedido',

                },
                {
                    key: 'proposta',
                    label: 'Proposta',

                },
                {
                    key: 'distribuidor.nome',
                    label: 'Cliente',
                    formatter: (value, key, item) => {
                        return item.distribuidor.codigo + ' - ' + item.distribuidor.nome
                    }
                },
                {
                    key: 'pedido_protheus',
                    label: 'Pedido Protheus'
                },
                {
                    key: 'proposta.tipo_proposta',
                    label: 'Tipo da Proposta',
                    formatter: (value) => {
                        return value == 'AMOSTRA_DISTRIBUIDOR' ? 'AMOSTRA DISTRIBUIDOR' : value
                    }
                },
                {
                    key: 'status',
                    label: 'Situação',
                    formatter: (value) => {
                        return this.getSituacao(value)
                    }
                },
                {
                    key: 'created_at',
                    label: 'Data',
                    formatter: (value) => {
                        return moment(value).format("DD/MM/YYYY")
                    }
                },
                {
                    key: 'valor_bruto',
                    label: 'R$ Bruto',
                    formatter: (value) => {
                        return value.toString().replace('.', ',')
                    }
                },
                {
                    key: 'valor_liquido',
                    label: 'R$ Liquido',
                    formatter: (value) => {
                        return value.toString().replace('.', ',')
                    }
                },
                {
                    key: 'nota',
                    label: 'NF',
                    formatter: (value, key, item) => {
                        let notas = '';
                        item.xml.forEach((el, index) => {
                            if (el.nota) {
                                if (notas) {
                                    notas += ',' + el.nota
                                } else {
                                    notas += el.nota
                                }
                            }
                        })
                        return notas
                    }
                },
                {
                    key: 'actions',
                    label: '',
                }
            ],
            loadingFalta: false,
            pedidoFaltas: {
                id: ''
            },
            modalPedido: false,
        }
    },
    methods: {
        gerarPedidoFaltante() {
            const vm = this;
            vm.loadingFalta = true;
            axios.post('/venda-direta/gerar-pedido-falta', this.pedidoFaltas)
                .then((response) => {
                    // console.log(response);
                    vm.currentPage = 1;
                    vm.listaPedidos();
                    vm.modalPedido = false;
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    vm.loadingFalta = false;
                })
        },
        getPedidoFaltante(id) {
            const vm = this;
            vm.loadingFalta = true;
            axios.get('/venda-direta/get-falta-pedido/' + id)
                .then((response) => {
                    vm.pedidoFaltas = response.data;
                    vm.pedidoFaltas.itens.forEach((el) => {
                        el.qtdARecuperar = parseInt(el.quantidade) - parseInt(el.quantidade_atendida)
                    })
                    vm.modalPedido = true;
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    vm.loadingFalta = false;
                })
        },
        verProposta(id) {
            window.location.href = '/venda-direta/proposta/' + id + '/edit'
        },
        getSituacao(value) {
            if (value == 'ANALISE_CREDITO') return 'ANÁLISE DE CRÉDITO'
            else return value
        },
        limpar() {
            this.filter = '';
            this.buscar();
        },
        buscar() {
            this.pedidos = [];
            this.currentPage = 1;
            this.listaPedidos();
        },
        gerarNota(id) {
            window.open('/venda-direta/danfe/' + id, '_blank');
        },
        gerarNotaBrinde(id) {
            window.open('/venda-direta/danfe-brinde/' + id, '_blank');
        },
        voltar() {
            window.location.href = "/venda-direta/"
        },

        propostaVarejo() {
            window.location.href = "/venda-direta/propostas/"
        },

        imprimir(id) {
            window.open('/venda-direta/pedidos/' + id + '/imprimir', '_blank');
        },

        listaPedidos() {
            const vm = this;
            vm.isLoading = true;
            vm.pedidos = [];
            const data = {
                perPage: vm.perPage,
                currentPage: vm.currentPage,
                cliente: vm.filtro.cliente,
                tipo: vm.filtro.tipo,
                protheus: vm.filtro.protheus,
                status: vm.filtro.status,
                nota: vm.filtro.nota,
                pedido: vm.filtro.pedido
            }
            axios.get("/venda-direta/pedidos/listar", { params: data })
                .then((response) => {
                    vm.totalRows = response.data.total;
                    vm.pedidos = response.data.data
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    vm.isLoading = false;
                })
        },
        hasPermission(value) {
            // console.log(this.permissions.some(el => el.name == value))
            return this.permissions.some(el => el.name == value)
        },
        getPermission() {
            axios.get('/adm/users/getpermissions')
                .then((response) => {
                    this.permissions = response.data.permissions;
                }).catch((erro) => {
                    console.log('erro ao buscar permissoes', erro);
                })
        },
        hasFalta(pedido) {
            const data = pedido.itens.some((el) => pedido.status !== 'CANCELADO' && !pedido.proposta.pedido_falta_id && el.quantidade_atendida !== null && parseInt(el.quantidade) != parseInt(el.quantidade_atendida));
            return data
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY H:mm:ss")
        }
    },
    mounted() {
        this.listaPedidos();
        this.getPermission();
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/varejo/pedidos/index.vue